import * as React from "react";
import {ConfigContext} from "../../../context/ConfigContext";
import {Company, CompanyConfiguration, SFTPSyncConfiguration} from "../../../../../generated/api";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {workingConfig} from "../../configChange/ConfigSignal";
import {Button, Card, CardGroup, Checkbox, Label} from "semantic-ui-react";
import AceEditor from "react-ace";
import {LogView} from "../../logView/LogView";
import {ChangeableSplitter} from "../../../../util/table-splitter-ui/src/components/Splitters/ChangableSplitter";
import {v4 as uuid} from 'uuid';

export interface FtpSyncerProps {

}

export function FtpSyncer(props: React.PropsWithChildren<FtpSyncerProps>) {

    const context = React.useContext(ConfigContext)
    const [loading, setLoading] = React.useState(false);
    const [xRequestId, setXRequestId] = React.useState("");
    const [response, setResponse] = React.useState(null);
    const [createTestFile, setCreateTestFile] = React.useState(true);


    interface RunAllSyncJobsRequest {
        companyId: string,
        companyConfiguration: CompanyConfiguration
        company: Company,
        createTestFile: boolean
    }


    async function sync() {
        console.log("Syncing...");
        setLoading(true);
        let auth = backend.withTokenAuthHeader(authentication.token);
        let url = "/fileSystemWorker/runAllSyncJobs"
        let xReqId = uuid()


        let request = {} as RunAllSyncJobsRequest;
        request.companyId = context.companyId;
        request.companyConfiguration = JSON.parse(workingConfig.value);
        request.company = authentication.company;
        request.company._id = context.companyId;
        request.createTestFile = createTestFile;

        let response = await fetch(url, {
            method: "POST",
            headers: {
                "Authorization": auth.headers.Authorization.toString(),
                "Content-Type": "application/json",
                'x-request-ID': xReqId,

            },
            body: JSON.stringify(request, null, 4)
        });
        setResponse(await response.json());
        setXRequestId(xReqId);
        setLoading(false);

    }

    function topLeftSide() {

        return <>
            <h1>FTP Syncer</h1>

            <>create a testFile : <Checkbox
                type='checkbox'
                toggle
                checked={createTestFile}
                onChange={() => {
                    setCreateTestFile(!createTestFile)
                }}
            /></>

            <Button
                style={{marginTop: "5px"}}
                onClick={sync}
                primary
                loading={loading}
            >Sync</Button>
            <h3>Response:</h3>
            <AceEditor
                theme="monokai"
                style={{flex: 1}}
                mode="json"
                value={JSON.stringify(response, null, 4)}
                placeholder={'Nothing found'}
                width="100%"
                height={window.innerHeight - 200 + "px"}
                readOnly={true}
            />
        </>
    }

    function bottomRightSide() {
        return <LogView
            query={xRequestId}
            origin={"FtpSyncerPage"}
            initialTimespan={null}
            responseLogs={null}
        />
    }

    return <ChangeableSplitter
        name={"FtpSyncerPage"}
        initiallyHorizontal
        topOrLeft={topLeftSide()}
        bottomOrRight={bottomRightSide()}
    />
}